import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import * as moment from "moment";
import 'moment/locale/es';
import { HomeService } from "../../home.service";
import { setting } from "../../../../../setting";
import { LoginService } from "../../login/login.service";
import { BehaviorSubject, Subscription } from "rxjs";
import { NotificationService } from "../../../../app/shared/notifications/notification.service";


@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  providers: [HomeService],
})
export class HeaderComponent implements OnInit, OnDestroy  {
  @Input() id: number;
  @Input() change_password: number;
  @Input() two_factor_enabled: boolean = false;
  @Input() clientSetting: any;
  public twoFactorFeatureEnabled = setting.twoFactorEnabled;
  public twoFactorModal: boolean = false;
  fechaa = moment().format("Do MMMM YYYY");
  menuHidden = true;
  isCollapsed = false;
  public getClientsSettingAppAuth: any;
  public sectionHeader: any;
  public routeUploadFile:any;
  headerClass$ = new BehaviorSubject<string>('');
  headerClass: string = '';
  logoPath$ = new BehaviorSubject<string>('');
  showButton$ = new BehaviorSubject<boolean>(true);
  showHomeIcons$ = new BehaviorSubject<boolean>(true);
  showSelectIcons$ = new BehaviorSubject<boolean>(false);
  public user: any;
  public isOpenOption: boolean = false;
  public hoverColor: string = '';
  public colorWhite: string = '#ffffff';
  public changePassModal: boolean = false;
  public isClickedInside: boolean = false;
  public changePassword: boolean = false;
  public documentClickHandler: any;
  fadeOut: boolean = false;
  public wsp_number: string;
  public pdfHelp: string;
  isCenterLogo = 0;
  private logoutSubscription: Subscription;
  private routeEventsStyleSubscription: Subscription;
  private routeEventsLogotypeSubscription: Subscription;
  private routeEventsButtonSubscription: Subscription;
  private routeEventsHomeIconsSubscription: Subscription;

  constructor(private router: Router,
     private _loginService: LoginService,
     public _router: Router,
     public notificationService: NotificationService,
     private cdr: ChangeDetectorRef
     ) {


  }

  ngOnInit() {
    this.getClientsSettingAppAuth = this.clientSetting;
    this.routeUploadFile =  setting.routeUploadFile;
    this.sectionHeader = JSON.parse(this.getClientsSettingAppAuth?.clients_setting_app_auth?.section_header);
    this.isCenterLogo = this.sectionHeader?.isCenterLogo;
    moment.locale('es');
    let wspNumber = this.getClientsSettingAppAuth?.wsp_phone_number;

    // Eliminar el signo + y los espacios en blanco
    wspNumber = wspNumber.replace(/\+/g, '').replace(/\s/g, '');

    this.wsp_number = wspNumber;

    const concatPdf = setting.apiStorageBooking;
    this.pdfHelp = concatPdf + "manuales/Manual_Auth.pdf";

/*------------- Instance change style, logo and icon of route  -----------------*/

      this.headerClass$.next(this.sectionHeader?.background_1);
      this.logoPath$.next(this.routeUploadFile + this.sectionHeader?.logotype_header_1);
      this.showButton$.next(true);
      // Detectar la ruta actual al cargar la página
      this.updateHeaderStyle(this.router.url);

      // Suscribirse a los cambios de ruta
      this.routeEventsStyleSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.updateHeaderStyle(event.url);
        }
 });

    setTimeout(() => {
      if(this.change_password === 0) {
        this.changePassword = true;
      } else {
        this.changePassword = false;
      }
    }, 1500);

  }

  // Método reutilizable para actualizar los valores según la ruta
private updateHeaderStyle(url: string) {
  if (url === '/home') {
    this.headerClass$.next(this.sectionHeader?.background_1);
    this.logoPath$.next(this.routeUploadFile + this.sectionHeader?.logotype_header_1);
    this.showButton$.next(true);
    this.showHomeIcons$.next(true);
    this.showSelectIcons$.next(false);
  } else if (url === '/select') {
    this.headerClass$.next(this.sectionHeader?.background_2);
    this.logoPath$.next(this.routeUploadFile + this.sectionHeader?.logotype_header_2);
    this.showButton$.next(false);
    this.showHomeIcons$.next(false);
    this.showSelectIcons$.next(true);
  }
}

  onLogout() {
    // El logout solo es clickeable en /select, para entonces initUser() ya
    // pobló este caché — evita guardar el perfil completo (PII) en localStorage
    // solo para tener el email a mano acá.
    this._loginService.getCurrentCached().subscribe({
      next: (data: any) => {
        this.user = data?.det;
        this.doLogout(this.user?.email);
      },
      error: () => this.doLogout(undefined),
    });
  }

  private doLogout(email: string | undefined) {
    this.logoutSubscription = this._loginService.logout({ email }).subscribe(
      (data: any) => {
        this._loginService.clearCurrentUserCache();
        this._router.navigate(["/home", {}]);
      },
      (error) => {
        this.notificationService.error(JSON.parse(error._body).det);
      }
    );
  }

  toggleChangeOption() {
    this.isOpenOption = !this.isOpenOption;
  }

  setHoverColor(color: string) {
    this.hoverColor = color;
  }

  openChangePass() {
    this.isOpenOption = true;
    this.changePassModal = true;
    this.isClickedInside = true;
  }

  closeChangePass() {
    this.changePassModal = false;
    this.isOpenOption = false;
    this.isClickedInside = false;
  }

  openTwoFactor() {
    this.isOpenOption = true;
    this.twoFactorModal = true;
    this.isClickedInside = true;
  }

  closeTwoFactor() {
    this.twoFactorModal = false;
    this.isOpenOption = false;
    this.isClickedInside = false;
  }

  onClick() {
    if (!this.isClickedInside) {
      this.closeChangePass();
      this.closeTwoFactor();
    }
    this.isClickedInside = false;
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.documentClickHandler);
    // this.logoutSubscription.unsubscribe();
    // this.routeEventsStyleSubscription.unsubscribe();
    // this.routeEventsLogotypeSubscription.unsubscribe();
    // this.routeEventsButtonSubscription.unsubscribe();
    // this.routeEventsHomeIconsSubscription.unsubscribe();
  }

  fadeOutAnimation() {
    this.fadeOut = true;
    setTimeout(() => {
      this.fadeOutAnimationComplete();
    }, 3500);

  }

  fadeOutAnimationComplete() {
    this.changePassModal = false;
    this.changePassword = false;
    this.isOpenOption = false;
  }

  closeChangePassword() {

    setTimeout(() => {
      if(this.change_password === 0) {
        this.changePassword = true;
      } else {
        this.changePassword = false;
      }
    }, 1000);
    this.changePassModal = false;
    this.isOpenOption = false;
  }

}
